import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

type PlacementType = 'top' | 'left' | 'right' | 'bottom';

export const ToolTip = ({
  content,
  children,
  ...rest
}: {
  content: JSX.Element | string | null;
  placement: PlacementType | undefined;
  children: JSX.Element | string;
}): JSX.Element => {
  return (
    <Tippy content={content} {...rest}>
      <span>{children}</span>
    </Tippy>
  );
};

ToolTip.displayName = 'ToolTip';
